 
import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseDidInUser,
  fetchDidInUser,
  fetchDidInUserSuccess,
  fetchDidInUserFailed,
  fetchClearDidInUser,
  fetchAddDidsInUser,
  fetchAddDidsInUserFailed,
  fetchAddDidsInUserSuccess,
  fetchMigrateDidsInUser,
  fetchMigrateDidsInUserSuccess,
  fetchMigrateDidsInUserFailed,
  fetchRegenerateAPIKey,
  fetchRegenerateAPIKeyFailed,
  fetchRegenerateAPIKeySuccess,
  saveLayoutMonitoringSuccess,
  saveLayoutContactSuccess,
} from 'redux/handleReducers';
import UserServices from 'services/UserServices';

const {
  REQUEST_API_USERSERVLET,
  REQUEST_API_USERSERVLET_SUCCESS,
  REQUEST_API_USERSERVLET_FAILED,
  REQUEST_CLEAR_USERSERVLET,
  REQUEST_GET_LIST_USERS,
  REQUEST_GET_LIST_USERS_SUCCESS,
  REQUEST_GET_LIST_USERS_FAILED,
  REQUEST_DELETE_USERS,
  REQUEST_DELETE_USERS_SUCCESS,
  REQUEST_DELETE_USERS_FAILED,
  REQUEST_CREATE_USERS,
  REQUEST_CREATE_USERS_SUCCESS,
  REQUEST_CREATE_USERS_FAILED,
  REQUEST_SHOW_DIDS,
  REQUEST_SHOW_DIDS_SUCCESS,
  REQUEST_SHOW_DIDS_FAILED,
  REQUEST_MIGRATE_DIDS,
  REQUEST_MIGRATE_DIDS_SUCCESS,
  REQUEST_MIGRATE_DIDS_FAILED,
  REQUEST_ADD_DIDS,
  REQUEST_ADD_DIDS_SUCCESS,
  REQUEST_ADD_DIDS_FAILED,
  REQUEST_DELETE_VIRTUALPHONE,
  REQUEST_DELETE_VIRTUALPHONE_SUCCESS,
  REQUEST_DELETE_VIRTUALPHONE_FAILED,
  REQUEST_ADD_CREDITS_USER,
  REQUEST_ADD_CREDITS_USER_FAILED,
  REQUEST_ADD_CREDITS_USER_SUCCESS,
  REQUEST_CLONE_USER,
  REQUEST_CLONE_USER_SUCCESS,
  REQUEST_CLONE_USER_FAILED,
  CLEAR_SHOW_DIDS,
  REQUEST_GET_TABLE_PRICE,
  REQUEST_GET_TABLE_PRICE_SUCCESS,
  REQUEST_GET_TABLE_PRICE_FAILED,
  REQUEST_BACKUP_NOW,
  REQUEST_BACKUP_NOW_SUCCESS,
  REQUEST_BACKUP_NOW_FAILED,
  REQUEST_RESTORE,
  REQUEST_RESTORE_FAILED,
  REQUEST_RESTORE_SUCCESS,
  REQUEST_EXPORT_USER,
  REQUEST_EXPORT_USER_SUCCESS,
  REQUEST_EXPORT_USER_FAILED,
  REQUEST_REGENERATE_API_KEY,
  REQUEST_REGENERATE_API_KEY_SUCCESS,
  REQUEST_REGENERATE_API_KEY_FAILED,
} = types;

const initialState = {
  isFetching: false,
  isFetchingUser: true,

  isDeleting: false,
  isCreating: false,
  isAddingCredit: false,
  isExportingUser: false,
  isCloning: false,
  isBackingUp: false,
  isFetchingTablePrice: false,
  isRestoring: false,

  isRegenerateAPIKey: false,

  data: undefined,

  listUsers: [],
  total: 0,
  ...baseDidInUser(),
};

export default (state, actions) => {
  const listActions = {
    [REQUEST_REGENERATE_API_KEY]: () => fetchRegenerateAPIKey(actions, state),
    [REQUEST_REGENERATE_API_KEY_SUCCESS]: () => fetchRegenerateAPIKeySuccess(actions, state),
    [REQUEST_REGENERATE_API_KEY_FAILED]: () => fetchRegenerateAPIKeyFailed(actions, state),
    [REQUEST_EXPORT_USER]: () => ({
      ...state,
      isExportingUser: true,
    }),
    [REQUEST_EXPORT_USER_SUCCESS]: () => ({
      ...state,
      isExportingUser: false,
    }),
    [REQUEST_EXPORT_USER_FAILED]: () => ({
      ...state,
      error: actions.error,
      isExportingUser: false,
    }),
    [REQUEST_RESTORE]: () => ({
      ...state,
      isRestoring: true,
    }),
    [REQUEST_RESTORE_SUCCESS]: () => ({
      ...state,
      isRestoring: false,
    }),
    [REQUEST_RESTORE_FAILED]: () => ({
      ...state,
      errorTablePrice: actions.error,
      isRestoring: false,
    }),
    [REQUEST_GET_TABLE_PRICE]: () => ({
      ...state,
      isFetchingTablePrice: true,
    }),
    [REQUEST_GET_TABLE_PRICE_SUCCESS]: () => ({
      ...state,
      isFetchingTablePrice: false,
    }),
    [REQUEST_GET_TABLE_PRICE_FAILED]: () => ({
      ...state,
      errorTablePrice: actions.error,
      isFetchingTablePrice: false,
    }),
    [REQUEST_BACKUP_NOW]: () => ({
      ...state,
      isBackingUp: true,
    }),
    [REQUEST_BACKUP_NOW_SUCCESS]: () => ({
      ...state,
      isBackingUp: false,
    }),
    [REQUEST_BACKUP_NOW_FAILED]: () => ({
      ...state,
      errorBackup: actions.error,
      isBackingUp: false,
    }),
    [REQUEST_CLONE_USER]: () => ({
      ...state,
      isCloning: true,
    }),
    [REQUEST_CLONE_USER_SUCCESS]: () => ({
      ...state,
      isCloning: false,
    }),
    [REQUEST_CLONE_USER_FAILED]: () => ({
      ...state,
      errorClone: actions.error,
      isCloning: false,
    }),
    [REQUEST_ADD_CREDITS_USER]: () => ({
      ...state,
      isAddingCredit: true,
    }),
    [REQUEST_ADD_CREDITS_USER_SUCCESS]: () => ({
      ...state,
      isAddingCredit: false,
    }),
    [REQUEST_ADD_CREDITS_USER_FAILED]: () => ({
      ...state,
      errorAddCredit: actions.error,
      isAddingCredit: false,
    }),
    [REQUEST_DELETE_VIRTUALPHONE]: () => ({
      ...state,
      isDeletingDids: true,
    }),
    [REQUEST_DELETE_VIRTUALPHONE_SUCCESS]: () => {
      let listDid = state.didInUser.listDid.filter((item) => item.phone != actions.phone);
      let didInUser = { ...state.didInUser, listDid };

      return {
        ...state,
        didInUser,
        isDeletingDids: false,
      };
    },
    [REQUEST_DELETE_VIRTUALPHONE_FAILED]: () => ({
      ...state,
      errorAddDids: actions.error,
      isDeletingDids: false,
    }),
    [REQUEST_ADD_DIDS]: () => fetchAddDidsInUser(actions, state),
    [REQUEST_ADD_DIDS_SUCCESS]: () => fetchAddDidsInUserSuccess(actions, state),
    [REQUEST_ADD_DIDS_FAILED]: () => fetchAddDidsInUserFailed(actions, state),

    [REQUEST_MIGRATE_DIDS]: () => fetchMigrateDidsInUser(actions, state),
    [REQUEST_MIGRATE_DIDS_SUCCESS]: () => fetchMigrateDidsInUserSuccess(actions, state),
    [REQUEST_MIGRATE_DIDS_FAILED]: () => fetchMigrateDidsInUserFailed(actions, state),

    [REQUEST_SHOW_DIDS]: () => fetchDidInUser(actions, state),
    [REQUEST_SHOW_DIDS_SUCCESS]: () => fetchDidInUserSuccess(actions, state),
    [REQUEST_SHOW_DIDS_FAILED]: () => fetchDidInUserFailed(actions, state),
    [CLEAR_SHOW_DIDS]: () => fetchClearDidInUser(actions, state),

    [types.REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS]: () =>
      saveLayoutMonitoringSuccess(actions, state),
    [types.REQUEST_SAVE_LAYOUT_CONTACT_SUCCESS]: () => saveLayoutContactSuccess(actions, state),

    [REQUEST_CREATE_USERS]: () => ({
      ...state,
      isCreating: true,
    }),
    [REQUEST_CREATE_USERS_SUCCESS]: () => ({
      ...state,
      listUsers: [actions.itemRecentCreated, ...state.listUsers],
      isCreating: false,
      total: state.total + 1,
    }),
    [REQUEST_CREATE_USERS_FAILED]: () => ({
      ...state,
      errorCreate: actions.error,
      isCreating: false,
    }),
    [REQUEST_DELETE_USERS]: () => ({
      ...state,
      isDeleting: true,
    }),
    [REQUEST_DELETE_USERS_SUCCESS]: () => ({
      ...state,
      isDeleting: false,
    }),
    [REQUEST_DELETE_USERS_FAILED]: () => ({
      ...state,
      isDeleting: false,
      errorDeleting: actions.error,
    }),
    [REQUEST_GET_LIST_USERS]: () => ({
      ...state,
      isFetchingUser: true,
    }),
    [REQUEST_GET_LIST_USERS_SUCCESS]: () => ({
      ...state,
      listUsers: actions.data,
      total: actions.total,
      isFetchingUser: false,
    }),
    [REQUEST_GET_LIST_USERS_FAILED]: () => ({
      ...state,
      isFetchingUser: false,
      errorGetListUser: actions.error,
    }),
    [REQUEST_API_USERSERVLET]: () => ({
      ...state,
      isFetching: !!!actions.refetch,
    }),
    [REQUEST_API_USERSERVLET_SUCCESS]: () => ({
      ...state,
      data: actions.payload,
      isFetching: false,
    }),
    [REQUEST_API_USERSERVLET_FAILED]: () => ({
      ...state,
      error: actions.error,
      data: UserServices.getCachedUser(),
      isFetching: false,
    }),
    [REQUEST_CLEAR_USERSERVLET]: () => initialState,
  };
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  if (listActions[actions.type]) {
    return listActions[actions.type]();
  }
  return state;
};
